/**
 * Supabase Auth anti-enumeration: when signing up with an email that already
 * belongs to an account (password or OAuth/Google), `signUp` often returns
 * HTTP 200 with no session and either no user or `user.identities === []`.
 * **No confirmation email is sent** in that case — the UI must not claim it was.
 *
 * @see https://supabase.com/docs/reference/javascript/auth-signup
 */
export function isLikelyExistingAccountSignUp(data: {
  user?: { identities?: Array<unknown> | null } | null;
  session?: unknown;
}): boolean {
  if (data.session) return false;
  const user = data.user;
  if (!user) return true;
  const identities = user.identities;
  if (!identities || identities.length === 0) return true;
  return false;
}
